import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from './apiAuth';
import { authHeader, canonicalizeResponse } from './common';

export const fetchAllCategoryData = createAsyncThunk(
  'profile/fetchAllCategoryData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/profile-surveys/categories', {
        headers: await authHeader(),
      });
      return canonicalizeResponse(response);
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch category data');
    }
  }
);

export const submitCategoryData = createAsyncThunk(
  'profile/submitCategoryData',
  async ({ categoryData }, { rejectWithValue }) => {
    try {
      const response = await api.post('/profile-surveys/categories/submit', { categoryData }, {
        headers: await authHeader(),
      });
      return canonicalizeResponse(response);
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to submit category data');
    }
  }
);

const initialState = {
  allCategoryData: {},
  is_success: false,
  isLoading: false,
  error: null,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllCategoryData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllCategoryData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allCategoryData = action.payload;
        state.is_success = true;
      })
      .addCase(fetchAllCategoryData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.is_success = false;
      })
      .addCase(submitCategoryData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(submitCategoryData.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(submitCategoryData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default profileSlice.reducer;
